import { addDoc, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { SalesChannel, salesChannelsRef } from '@api/SalesChannels/SalesChannel';
import { getBase64, getBase64Extension, getBase64MimeType, isBase64 } from '@utils/Base64';
import StorageServ from '@api/Firebase/StorageService/StorageServ';

const SALES_CHANNELS_PATH = 'salesChannels/';
export default {
    async saveSalesChannel(salesChannel: SalesChannel): Promise<SalesChannel> {
        if (!salesChannel.id) {
            const salesChannelExist = await this.getSalesChannelByName(salesChannel.name);
            if (salesChannelExist) {
                throw new Error('Canal de venta existente.');
            }
            const data = await addDoc(salesChannelsRef, salesChannel);
            salesChannel.id = data.id;
        }
        if (salesChannel.photoSrc && isBase64(getBase64(salesChannel.photoSrc))) {
            salesChannel.photoSrc = await this.uploadPhoto(salesChannel.photoSrc, salesChannel.id);
        }
        await updateDoc(doc(salesChannelsRef, salesChannel.id), { ...salesChannel });
        return salesChannel;
    },
    async getSalesChannels(): Promise<SalesChannel[]> {
        const salesChannels: SalesChannel[] = [];
        const queryDoc = query(salesChannelsRef);
        const snapshot = await getDocs(queryDoc);
        if (snapshot.empty) {
            return salesChannels;
        }
        snapshot.docs.map((doc: any) => {
            salesChannels.push(doc.data() as SalesChannel);
        });
        return salesChannels;
    },
    async getSalesChannel(salesChannelId: string): Promise<SalesChannel> {
        const documentData = await getDoc(doc(salesChannelsRef, salesChannelId));
        return documentData.data() as SalesChannel;
    },
    async getSalesChannelByName(name: string): Promise<SalesChannel | undefined> {
        let salesChannel = undefined;
        const querySalesChannel = query(salesChannelsRef, where('name', '==', name));
        const snapshot = await getDocs(querySalesChannel);
        if (snapshot.empty) {
            return salesChannel;
        }
        snapshot.forEach((doc: any) => {
            salesChannel = doc.data() as SalesChannel;
        });
        return salesChannel;
    },
    async deleteSalesChannel(salesChannelId: string): Promise<void> {
        await deleteDoc(doc(salesChannelsRef, salesChannelId));
        return;
    },
    async uploadPhoto(photoBase64: string, salesChannelId: string): Promise<string> {
        const path = `${SALES_CHANNELS_PATH}${salesChannelId}.${getBase64Extension(photoBase64)}`;
        return await StorageServ.uploadFileToStorage(path, getBase64(photoBase64), getBase64MimeType(photoBase64));
    }
};
